/**
*  Function to make ajax call
*   @param {object} requestObj -
*   {
*       'method': 'GET'
*       'url': 'https://autosug.qa.ebay.com/autosug?_dg=0&sId=0&callback=0&kwd=i',
*       'responseType': 'json'
*   }
*   @param {object} callBacks -
*   {
*       'successCallBack': function(data){},
*       'errorCallBack': function(textStatus){}
*   }
**/
export const ajax = (requestObj, callBacks, timeout) => {
    const method = requestObj.method || 'GET';
    const url = requestObj.url;
    const responseType = requestObj.responseType || 'json';
    const xhr = new XMLHttpRequest();
    xhr.withCredentials = requestObj.withCredentials;
    xhr.open(method, url);
    if (typeof timeout !== 'undefined') {
        xhr.timeout = timeout;
        xhr.ontimeout = () => {
            xhr.abort();
            if (callBacks.errorCallBack) {
                callBacks.errorCallBack(xhr.statusText);
            }
        };
    }
    xhr.responseType = responseType;
    xhr.onload = () => {
        if (xhr.status === 200 && callBacks.successCallBack) {
            callBacks.successCallBack(xhr.response);
        } else if (callBacks.errorCallBack) {
            callBacks.errorCallBack(xhr.statusText);
        }
    };
    xhr.onerror = () => {
        if (callBacks.errorCallBack) {
            callBacks.errorCallBack(xhr.statusText);
        }
    };
    xhr.send();
};
